module.exports = __webpack_public_path__ + "img/cleanup5-7-8-2021.34cb02d6.jpg";